import React, { useState, useCallback, useEffect } from "react";
import { connect } from "react-redux";
import "../css/omstyle.css";
import apiRoutes from "../../assets/apiRoutes.json";
import SelectBox from 'devextreme-react/select-box';
import DataSource from 'devextreme/data/data_source';
import CustomStore from 'devextreme/data/custom_store';
import LookupSearchDialog from "../services/LookupSearchDialog";
import AccordionReact from 'devextreme-react/accordion';
import { GetFormatedDateWithTime } from '../../common/Utils'
import AutoCompleteComponent from '../services/AutoCompleteComponent'
import { Button } from 'devextreme-react/button';
import TextBox from 'devextreme-react/text-box';
import data from "../../assets/apiRoutes.json";
import axios from "axios";
import { useHistory } from 'react-router-dom';
import DateBox from 'devextreme-react/date-box';
import OMDetailItems from "./OMDetailItems";
import { LoadPanel } from 'devextreme-react/load-panel';
import { ABECASUSER_LOGIN_TYPE, CONSIGNEE_LOGIN_TYPE } from "../../common/permissions";
import notify from 'devextreme/ui/notify';
import Toolbar, { Item } from "devextreme-react/toolbar";

const panel = [
    {
        ID: 1,
        Title: 'Create Quote'
    }
];
const CreateTransaction = (props) => {
    console.log('props',props)
    var accessToken = props.oidc.user.access_token;
    const [stage, setStage] = useState(props.selectedTab === "Quote" ? "Q" : "P");
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const [showIndicator, setShowIndicator] = useState(true);
    const [shading, setShading] = useState(true);
    const [showPane, setShowPane] = useState(true);
    const [hideOnOutsideClick, setHideOnOutsideClick] = useState(false);
    const [resetTrigger, setResetTrigger] = useState(false);
    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, [setLoadPanelVisible]);
    const [formData, setFormData] = useState({
        transactionnumber: "",
        transactionDate: "",
        shippingDate: "",
        shippernameto: "",
        rShipper: "",
        rShipperTo: "",
        reference: "",
        rCustomerFrom: "",
        rCustomerTo: "",
        customernamefrom: "",
        customernameto: "",
        identityId: "",
        stage: props.selectedTab==="Quote"?"Q":"P",
        status: "O",
        module: "OM",
        transactionType: "I",
        recordtype: "R",
        rProfile: "",
        profileVal: "",
        rShipperVia: "",
        shippernameVia: ""
    });
    const {
    } = formData;
    const today = new Date().toISOString().split('T')[0];
    const position = { of: '#accordion-containe2' };
    const [openLookupShipperTo, setOpenLookupShipperTo] = useState(false);
    const [searchPanelStatus, setSearchPanelStatus] = useState(true);
    const [transactionNumber, setTransactionNumber] = useState('');
    const [selectedCustomer, setSelectedCustomer] = useState('');
    const [headerRowId, setHeaderRowId] = useState('');
    const [transDate, setTransDate] = useState(today);
    const [shipDate, setShipDate] = useState('');
    const [openLookupCustomer, setOpenLookupCustomer] = useState(false);
    const [visibleDetailGrid, setVisibleDetailGrid] = useState(false);
    const [openLookupProfile, setOpenLookupProfile] = useState(false);
    const [openLookupShippVia, setOpenLookupShippVia] = useState(false);
    const [selectedItems, setSelectedItems] = useState([panel[0]]);
    const [success, setSuccess] = useState(false);
    const [IsVisible, setIsVisible] = useState(true);
    const [IsDisable, setIsDisable] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [warning, setwarning] = useState(false);
    const [poNumber, setPoNumber] = useState('');
    const [warningMessage, setwarningMessage] = useState('');
    const history = useHistory();
    const SHIPPER_ID_TO = "shipperidto";
    const CUSTOMER_ID_FROM = "customeridfrom";
    const SHIPPER_VIA = "shipperivia";
    const PROFILE = "profile";
    const lookups = {};
    lookups[SHIPPER_ID_TO] = {
        name: "ShipperTo",
        label: "Ship To:",
        lookupType: 5
    };
    lookups[CUSTOMER_ID_FROM] = {
        name: "CustomerFrom",
        label: "Customer:",
        lookupType: 3
    };
    lookups[PROFILE] = {
        name: "Profile",
        label: "Profile Code:",
        lookupType: 4
    };
    lookups[SHIPPER_VIA] = {
        name: "ShipperVia",
        label: "Shipper Via:",
        lookupType: 4
    };
    const handelOpenLookupShipperTo = () => {
        setOpenLookupShipperTo(true);
    }
    const handelOpenLookupCustomer = () => {
        setOpenLookupCustomer(true);
    }
    const handelOpenLookupProfile = () => {
        setOpenLookupProfile(true);
    }
    const handelOpenLookupShippVia = () => {
        setOpenLookupShippVia(true);
    }
    const goBack = () => {
        history.goBack();
    };
    const onTransactionDateChange = useCallback(
        (e) => {
            setTransDate(e.value);
        },
        [setTransDate],
    );
    const onShippingDateChange = useCallback(
        (e) => {
            setShipDate(e.value);
        },
        [setShipDate],
    );
    const onPoNumberChange = useCallback(
        (e) => {
            setPoNumber(e.value);
        },
        [setPoNumber],
    );

    const mapToDto = (formData) => {
        return {
            TransactionNumber: formData.transactionnumber,
            TransactionType: formData.transactionType,
            TransactionDate: GetFormatedDateWithTime(transDate),
            ShippingDate: GetFormatedDateWithTime(shipDate),
            RShipper: formData.rShipperTo,
            RCustomer: formData.rCustomerFrom,
            RShipVia: formData.rShipperVia,
            PoNumber: poNumber,
            Stage: stage,
            Status: formData.status,
            Module: formData.module,
            RecordType: formData.recordtype,
            RProfile: formData.rProfile,
        };
    };
    const handelReset = async (event) => {
        if(event.event)
        event.event.stopPropagation();
        setLoadPanelVisible(true);
        try {
            setFormData({
                transactionnumber: "",
                transactionDate: "",
                shippingDate: "",
                shippernameto: "",
                rShipper: "",
                shippernameVia: "",
                rShipperTo: "",
                reference: "",
                rCustomerFrom: "",
                rCustomerTo: "",
                customernamefrom: "",
                customernameto: "",
                identityId: "",
                stage: stage,
                status: "O",
                module: "OM",
                transactionType: "I",
                recordtype: "R",
                rProfile: "",
                profileVal: "",
                rShipperVia: "",
                shippernameVia: "",
            });
            const today = new Date().toISOString().split('T')[0];
            setPoNumber('');
            setTransactionNumber('');
            setTransDate(today);
            setShipDate('');
            setHeaderRowId('');
            setVisibleDetailGrid(false);
            setError(false);
            setErrorMessage("");
            setSuccess(false);
            setSuccessMessage("");
            setIsDisable(false);
            setIsVisible(true);
            setSelectedCustomer('');
            setSelectedValue('');
            setResetTrigger(prevState => !prevState);
        }
        catch (error) {
            console.log(error);
        }
        finally {
            setTimeout(hideLoadPanel, 1000);
        }

    }
    const handelSave = async (event) => {
        event.event.stopPropagation();
        setLoadPanelVisible(true);

        if (props.oidc.user.profile.hasOwnProperty("LOGINTYPEID") && props.oidc.user.profile.LOGINTYPEID == ABECASUSER_LOGIN_TYPE) {
            if (!formData.rProfile) {
                setError(true);
                setErrorMessage("Please enter profile:");
                notify(
                    {
                        message: "Please enter profile:",
                        width: 100,
                    },
                    'error',
                    3000,
                );
                setTimeout(hideLoadPanel, 1000);
                return;
            }
        }
        if (props.oidc.user.profile.hasOwnProperty("LOGINTYPEID") && (props.oidc.user.profile.LOGINTYPEID == ABECASUSER_LOGIN_TYPE || props.oidc.user.profile.LOGINTYPEID == CONSIGNEE_LOGIN_TYPE)) {
            if (!formData.rCustomerFrom) {
                setError(true);
                setErrorMessage("Please enter customer:");
                notify(
                    {
                        message: "Please enter customer:",
                        width: 100,
                    },
                    'error',
                    3000,
                );
                setTimeout(hideLoadPanel, 1000);
                return;
            }
        }

        if (!formData.rShipperTo) {
            setError(true);
            setErrorMessage("Please enter ship to:");
            notify(
                {
                    message: "Please enter ship to:",
                    width: 100,
                },
                'error',
                3000,
            );
            setTimeout(hideLoadPanel, 1000);
            return;
        }
        setError(false);
        setErrorMessage("");
        setIsDisable(true);
        try {
            const response = await axios.post(`${window._env_.REACT_APP_APIS}/${data.OM.CreateTransaction}`, mapToDto(formData)
                , {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                    },
                }
            );
            if (response.data.success) {
                notify(
                    {
                        message: response.data.message,
                        width: 600,
                    },
                    'success',
                    3000,
                );
                console.log(response.data)
                setTransactionNumber(response.data.transactionData.transactionNumber);
                setHeaderRowId(response.data.transactionData.rowId);
                if (response.data.warning) {
                    setwarning(true);
                    setwarningMessage(response.data.message);
                } else {
                    setSuccess(true);
                    setSuccessMessage(response.data.message);
                }
                setIsVisible(false);
                setVisibleDetailGrid(true);
                setIsDisable(false);
            }
            else {
                notify(
                    {
                        message: response.data.message,
                        width: 600,
                    },
                    'error',
                    3000,
                );
                setIsDisable(false);
                setError(true);
                setErrorMessage(response.data.message);
            }
        }
        catch (error) {
            setIsDisable(false);
            setError(true);
            setErrorMessage('Something went wrong');
        }
        finally {
            setSelectedValue('');
            setTimeout(hideLoadPanel, 1000);  
        }
    };
    const selectionChanged = useCallback(
        (e) => {
            let newItems = [...selectedItems];
            e.removedItems.forEach((item) => {
                const index = newItems.indexOf(item);
                if (index >= 0) {
                    newItems.splice(index, 1);
                }
            });
            if (e.addedItems.length) {
                newItems = [...newItems, ...e.addedItems];
            }
            setSelectedItems(newItems);
            setSearchPanelStatus((prevStatus) => {
                const newStatus = !prevStatus;
                return newStatus;
            });
        },
        [selectedItems, setSelectedItems],
    );

    const [shiptoData, setShiptoData] = useState();
    const [selectedValue, setSelectedValue] = useState();
    const [transactionSelectedLookupData, setTransactionLookupSelectedData] = useState({});
    const setTransactionLookupData = (selectedValue) => {
        fetchData(selectedValue[0].identityId);
        setSelectedValue(selectedValue[0]);
    }
    const onValueChanged = useCallback((e) => {
        setSelectedValue(e.value);
        setFormData(prevFormData => ({
            ...prevFormData,
            rShipperTo: e.value.rowid,
            shippernameto:e.value?.name,
        }));
    }, [setFormData]);
    const fetchData = async (kValue, selectedCustomer) => {
        //alert("fetchData.rCustomerFrom=" + selectedCustomer);
        setShiptoData(new DataSource({
            store: new CustomStore({
                key: 'rowid',
                load: async function (loadOptions) {
                    // console.log(JSON.stringify(props))
                    const searchValue = loadOptions.searchValue || kValue;
                    console.log("formData.rCustomerFrom=" + selectedCustomer);
                    let request = {
                        identityIdFrom: searchValue,
                        code: searchValue,
                        lookupType: 5,
                        IsAutoComplete: true,
                        CustomerId: selectedCustomer
                    };
                    return await axios.post(
                        `${window._env_.REACT_APP_APIS}/${apiRoutes.OM.SearchLookup}`,
                        request,
                        {
                            headers: {
                                "Content-Type": "application/json",
                                access_token: accessToken,
                                Authorization: `Bearer ${accessToken}`,
                            },
                        }
                    )
                        .then(response => response.data.lookups)
                        .catch(error => {
                            console.error('Error fetching data:', error);
                            return [];
                        });
                },
                byKey: async function (key) {
                    console.log("formData.rCustomerFrom=" + selectedCustomer);
                    let request = {
                        identityIdFrom: kValue,
                        code: kValue,
                        lookupType: 5,
                        isAutoComplete: true,
                        CustomerId: selectedCustomer
                    };
                    return await axios.post(
                        `${window._env_.REACT_APP_APIS}/${apiRoutes.Receipt.SearchLookup}`,
                        request,
                        {
                            headers: {
                                "Content-Type": "application/json",
                                access_token: accessToken,
                                Authorization: `Bearer ${accessToken}`,
                            },
                        }
                    )
                        .then(response => response.data.lookups)
                        .catch(error => {
                            console.error('Error fetching data:', error);
                            return [];
                        });
                }
            })
        }));
    }
    const handelCustomerChange = (data) => {
        setSelectedCustomer(data);
        setFormData(prevFormData => ({
            ...prevFormData,
            rShipperTo: "",
            shippernameto: ""
        }));
        setSelectedValue('');
        const inputElement = document.querySelector('#shipperTo');
        if (inputElement) {
            inputElement.value = '';
        }
    }

    useEffect(() => {
        fetchData('', selectedCustomer);
    }, [selectedCustomer]);


    return (
        <div>
            <div className="row">
                <div className="col-md-12 main-page">
                    <div id="accordion" >
                        <LoadPanel
                            position={position}
                            onHiding={hideLoadPanel}
                            visible={loadPanelVisible}
                            showIndicator={showIndicator}
                            shading={shading}
                            showPane={showPane}
                            hideOnOutsideClick={hideOnOutsideClick}
                        />
                        <AccordionReact
                            dataSource={panel}
                            collapsible={true}
                            multiple={false}
                            animationDuration={300}
                            selectedItems={selectedItems}
                            onSelectionChanged={e => {
                                if (e.currentTarget === e.target) {
                                    selectionChanged(e, e.target);
                                }
                            }}
                            itemTitleRender={() => (
                                <Toolbar className="accordian-toolbar">
                                    <Item location="before">
                                        <div className="title">
                                            <h6
                                                style={{color: window._env_.Color2}}
                                            >
                                                Create {props.selectedTab}
                                            </h6>
                                        </div>
                                    </Item>

                                    <Item location="after">
                                        <Button disabled={IsDisable} className="accordianButton" onClick={handelSave} text="Save" type="default" />
                                    </Item>
                                    <Item location="after">
                                        <Button disabled={IsDisable} className="accordianButton" onClick={handelReset} text="Reset" />
                                    </Item>
                                    <Item location="after">
                                        <Button disabled={IsDisable} className="accordianButton" onClick={goBack} text="Back" />
                                    </Item>
                                </Toolbar>
                            )}
                            itemRender={(itemProps) => (
                                <div>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <TextBox
                                                stylingMode='outlined'
                                                labelMode="static"
                                                label="Trans #"
                                                defaultValue=""
                                               
                                                value={transactionNumber}
                                                readOnly={true}
                                            />

                                        </div>
                                        <div className="col-md-3">
                                            <DateBox
                                                stylingMode='outlined'
                                                labelMode="static"
                                                label="Transaction Date:"
                                                defaultValue=''
                                                type="date"
                                                value={transDate}
                                                valueChangeEvent="keyup"
                                                onValueChanged={onTransactionDateChange}
                                                
                                            />
                                        </div>
                                        <div className="col-md-3">
                                            <DateBox
                                                stylingMode='outlined'
                                                labelMode="static"
                                                label="Shipping Date:"
                                                defaultValue=''
                                                type="date"
                                                value={shipDate}
                                                valueChangeEvent="keyup"
                                                onValueChanged={onShippingDateChange}
                                            />
                                        </div>
                                        <div className="col-md-3 d-flex align-items-center">
                                            <AutoCompleteComponent
                                                lookupInfo={lookups["shipperivia"]}
                                                openLookupForm={openLookupShippVia}
                                                setOpenLookupForm={setOpenLookupShippVia}
                                                setFormData={setFormData}
                                                formData={formData}
                                                className="AutoCompleteReactStyle"
                                                handelCustomerChange={handelCustomerChange}
                                                resetTrigger={resetTrigger}
                                            />
                                            <Button
                                                icon="search"
                                                onClick={handelOpenLookupShippVia}
                                                stylingMode="text"
                                            />
                                        </div>
                                    </div>
                                    <div className="row accordianLastRow">
                                        {props.oidc.user.profile.hasOwnProperty("LOGINTYPEID") && props.oidc.user.profile.LOGINTYPEID === ABECASUSER_LOGIN_TYPE && (
                                            <div className="col-md-3">
                                                <AutoCompleteComponent
                                                    lookupInfo={lookups["profile"]}
                                                    openLookupForm={openLookupProfile}
                                                    setOpenLookupForm={setOpenLookupProfile}
                                                    setFormData={setFormData}
                                                    formData={formData}
                                                    className="AutoCompleteReactStyle"
                                                    handelCustomerChange={handelCustomerChange}
                                                    resetTrigger={resetTrigger}
                                                />
                                            </div>
                                        )}
                                        {props.oidc.user.profile.hasOwnProperty("LOGINTYPEID") && (props.oidc.user.profile.LOGINTYPEID === ABECASUSER_LOGIN_TYPE || props.oidc.user.profile.LOGINTYPEID === CONSIGNEE_LOGIN_TYPE) && (
                                            <div className="col-md-3 d-flex align-items-center">
                                                <AutoCompleteComponent
                                                    lookupInfo={lookups["customeridfrom"]}
                                                    openLookupForm={openLookupCustomer}
                                                    setOpenLookupForm={setOpenLookupCustomer}
                                                    setFormData={setFormData}
                                                    formData={formData}
                                                    className="AutoCompleteReactStyle"
                                                    handelCustomerChange={handelCustomerChange}
                                                />
                                                <Button
                                                    icon="search"
                                                    onClick={handelOpenLookupCustomer}
                                                    stylingMode="text"
                                                />
                                            </div>
                                        )}
                                        <div className="col-md-3 d-flex align-items-center">
                                            <div className="col-md-11 auto-complete-selectbox">
                                            <SelectBox
                                                dataSource={shiptoData}
                                                displayExpr="identityId"
                                                searchEnabled={true}
                                                stylingMode='outlined'
                                                labelMode="static"
                                                label="Ship To"
                                                onValueChanged={onValueChanged}
                                                value={selectedValue}
                                                valueChangeEvent="keyup"
                                                id="shipperTo"
                                            />
                                            {
                                                openLookupShipperTo ?
                                                    <LookupSearchDialog
                                                        openLookupForm={openLookupShipperTo}
                                                        setOpenLookupForm={setOpenLookupShipperTo}
                                                        setReceipt={setFormData}
                                                        receipt={formData}
                                                        lookupFormName="ShipperTo"
                                                        lookup={lookups["shipperidto"]}
                                                        selectedCustomer={selectedCustomer}
                                                        setTransactionLookupData={setTransactionLookupData}
                                                        transactionSelectedLookupData={transactionSelectedLookupData}
                                                        setTransactionLookupSelectedData={setTransactionLookupSelectedData}
                                                    /> : null
                                            }
                                            </div>
                                            <Button
                                                icon="search"
                                                onClick={handelOpenLookupShipperTo}
                                                stylingMode="text"
                                            />
                                        </div>
                                        <div className="col-md-3">
                                            <TextBox
                                                stylingMode='outlined'
                                                labelMode="static"
                                                label="PO Number:"
                                                defaultValue=""                                        
                                                value={poNumber}
                                                valueChangeEvent="keyup"
                                                onValueChanged={onPoNumberChange}
                                            />
                                        </div>



                                    </div>
                                </div>
                            )}
                            id="accordion-container" className="accordion-height"
                        />
                        <OMDetailItems
                            searchPanelStatus={searchPanelStatus}
                            setVisibleDetailGrid={setVisibleDetailGrid}
                            headerRowId={headerRowId}
                            visibleDetailGrid={visibleDetailGrid}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(CreateTransaction);